export default "__VITE_ASSET__bbbe103f__"